/**
 * Gets the value of a query parameter from the current URL
 * @param {string} paramName - The name of the query parameter to retrieve
 * @returns {string|undefined} The value of the query parameter if it exists, undefined otherwise
 */
export default function getQueryParamValue(paramName) {
  if (typeof window === "undefined" || !window.location) {
    return undefined;
  }
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(paramName) || undefined;
}
